module.exports = __webpack_public_path__ + "img/2_259.81937613.png";